// extracted by mini-css-extract-plugin
export var box = "_68-1";
export var checkboxRow = "_68-8";
export var checked = "_68-2";
export var descriptionSpacer = "_68-a";
export var disabled = "_68-3";
export var icon = "_68-6";
export var input = "_68-0";
export var labelSpacer = "_68-9";
export var medium = "_68-5";
export var small = "_68-4";
export var text = "_68-7";